import { formatResolutionTime } from 'helpers'
import { AlertCircle, CheckCircle, Clock, FileText } from 'react-feather'
import { Card, CardBody, Spinner } from 'reactstrap'

const SummaryCard = ({
  icon: Icon,
  iconBg,
  iconColor,
  label,
  value,
  sub,
  isLoading,
}) => (
  <Card className="border-0 shadow-sm h-100" style={{ overflow: 'hidden' }}>
    <CardBody className="d-flex align-items-center gap-3 py-3 px-4">
      <div
        className="d-flex align-items-center justify-content-center flex-shrink-0"
        style={{
          width: 52,
          height: 52,
          borderRadius: 14,
          background: iconBg,
        }}
      >
        <Icon size={22} color={iconColor} strokeWidth={2} />
      </div>

      <div>
        <p
          className="mb-1 text-muted"
          style={{ fontSize: 12, fontWeight: 500, letterSpacing: '0.02em' }}
        >
          {label}
        </p>
        {isLoading ? (
          <div className="py-2">
            <Spinner size="sm" color="primary" />
          </div>
        ) : (
          <>
            <p
              className="mb-0 fw-bold"
              style={{ fontSize: 22, lineHeight: 1.2, color: '#1a1d23' }}
            >
              {value}
            </p>
            {sub && (
              <p
                className="mb-0 text-muted"
                style={{ fontSize: 11, marginTop: 2 }}
              >
                {sub}
              </p>
            )}
          </>
        )}
      </div>
    </CardBody>
  </Card>
)

const GrievanceSummaryCards = ({ summary, isLoading }) => {
  const data = summary ?? {
    totalGrievance: 0,
    resolvedGrievance: 0,
    avgTimeToResolveInSeconds: null,
  }

  const cards = [
    {
      icon: FileText,
      iconBg: '#EEF2FF',
      iconColor: '#4F46E5',
      label: 'Total Jumlah Laporan',
      value: data.totalGrievance ?? 0,
      sub: 'keseluruhan laporan',
    },
    {
      icon: CheckCircle,
      iconBg: '#ECFDF5',
      iconColor: '#059669',
      label: 'Terselesaikan',
      value: data.resolvedGrievance ?? 0,
      sub: `${data.totalGrievance ? ((data.resolvedGrievance / data.totalGrievance) * 100).toFixed(1) : 0}% dari total laporan`,
    },
    {
      icon: AlertCircle,
      iconBg: '#FFF7ED',
      iconColor: '#EA580C',
      label: 'Belum Terselesaikan',
      value: (data.totalGrievance ?? 0) - (data.resolvedGrievance ?? 0),
      sub: `${data.totalGrievance ? ((((data.totalGrievance ?? 0) - (data.resolvedGrievance ?? 0)) / data.totalGrievance) * 100).toFixed(1) : 0}% dari total laporan`,
    },
    {
      icon: Clock,
      iconBg: '#F0F9FF',
      iconColor: '#0284C7',
      label: 'Rata-rata Waktu Penyelesaian',
      value: formatResolutionTime(
        data.avgTimeToResolveInSeconds
          ? data.avgTimeToResolveInSeconds / 86400
          : null,
      ),
      sub: 'sejak laporan diterima',
    },
  ]

  return (
    <>
      <div
        className="d-flex d-lg-none mb-4 gap-3"
        style={{
          overflowX: 'auto',
          overflowY: 'hidden',
          WebkitOverflowScrolling: 'touch',
          scrollSnapType: 'x mandatory',
          paddingBottom: 4,
        }}
      >
        {cards.map((card, i) => (
          <div
            key={i}
            style={{
              minWidth: 220,
              scrollSnapAlign: 'start',
              flexShrink: 0,
            }}
          >
            <SummaryCard {...card} isLoading={isLoading} />
          </div>
        ))}
      </div>

      <div className="d-none d-lg-flex row g-3 mb-4">
        {cards.map((card, i) => (
          <div key={i} className="col-xl-3 col-lg-6">
            <SummaryCard {...card} isLoading={isLoading} />
          </div>
        ))}
      </div>
    </>
  )
}

export default GrievanceSummaryCards
